export default {
  httpURL: "https://sms.zberp.net/lfnsmsplatform",
}



// WEBPACK FOOTER //
// ./src/server/http.js